import useStyles from './styles';

const KEYS_THAT_TRIGGER_CLICK = ['Enter'];
const NON_BUTTON_TYPES = ['panel', 'icon'];

function Button({ children, type, onClick, disabled = false, ...props }: ButtonProps) {
  const classes = useStyles();
  const clickIfEnabled = () => {
    if (!disabled) {
      onClick();
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (KEYS_THAT_TRIGGER_CLICK.includes(event.key)) {
      clickIfEnabled();
    }
  };

  return NON_BUTTON_TYPES.includes(type) ? (
    <div
      data-testid={props['data-testid']}
      onClick={clickIfEnabled}
      role="button"
      tabIndex={0}
      onKeyDown={handleKeyDown}
      className={classes[type as NonButtonType]}
    >
      {children}
    </div>
  ) : (
    <button
      type="button"
      className={`${classes.buttonBase} ${classes[type]}`}
      data-testid={props['data-testid']}
      onClick={clickIfEnabled}
    >
      {children}
    </button>
  );
}

export default Button;
